import React from "react"
import { BLACK, PRIMARY, YELLOW } from "../../../ui/Colors";
import { PrimaryText } from "../../../ui/Text";
import { Step } from "react-joyride";
import { Grid } from "@mui/material";
import NotificationsIcon from '@mui/icons-material/Notifications';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

export const notificationsSteps = [
    {
        content: <Grid container direction="column" textAlign="left" width="25vw">
            <Grid container alignItems="center" pb="2vh">
                <NotificationsIcon
                    fontSize="large"
                    sx={{
                        color: YELLOW,
                        mr: 2,
                        position: 'relative',
                    }}
                /><PrimaryText color={BLACK} bold >Ne ratez rien !</PrimaryText >
            </Grid>
            <PrimaryText color={BLACK} pb="2vh">
                KaryonFood veille désormais sur vos performances en continue : <span style={{ fontWeight: "bold" }}>un risque critique ?</span> Je découvre son origine en 1 clic et je réagis rapidement. </PrimaryText>

            <PrimaryText color={BLACK} bold> Cliquez sur la cloche pour voir vos alertes.</PrimaryText>
        </Grid >,
        locale: { last: "Terminer" },
        disableBeacon: true,
        disableOverlayClose: true,
        hideCloseButton: true,
        hideFooter: true,
        placement: 'bottom-end',
        spotlightClicks: true,
        target: "#openNotifications",
        data: {},
    },
] as Step[]

export const notificationsClickedSteps = (position) => {
    return [
        {
            content: <Grid container direction="column" textAlign="left" width="25vw">
                <Grid container alignItems="center" pb="2vh">
                    <ArrowDownwardIcon
                        fontSize="small"
                        sx={{
                            color: PRIMARY,
                            mr: 2,
                            position: 'relative',

                        }}
                    /><PrimaryText color={BLACK} bold >Triez pour y voir plus clair !</PrimaryText >
                </Grid>
                <PrimaryText color={BLACK} pb="2vh">
                    Votre page a été filtrée sur le périmètre de l'alerte.
                </PrimaryText>
                <PrimaryText color={BLACK} >
                    En survolant l'en-tête (en surbrillance ci-dessous), une flèche apparait.<br /> Faites remonter vos reculs les plus importants en <span style={{ fontWeight: "bold" }}>cliquant sur cette flèche</span>
                </PrimaryText>
            </Grid >,
            locale: { last: "Je trie mon tableau" },
            disableBeacon: true,
            disableOverlayClose: true,
            hideCloseButton: true,
            hideFooter: true,
            placement: position,
            spotlightClicks: true,
            target: "#productTourClickedNotifications",
            data: {},
        },
    ]
} 